let html = `<div class="torrent-install">
    <div class="torrent-install__left">
        <img src="https://yumata.github.io/lampa/img/ili/tv.png" class="torrent-install"/>
    </div>
    <div class="torrent-install__details">
        <div class="torrent-install__title">#{torrent_install_need}</div>
        <div class="torrent-install__descr">#{torrent_install_text}</div>
        
        <div class="torrent-install__label">#{torrent_install_contact}</div>

        <div class="torrent-install__links">
            <div class="torrent-install__link">
                <div>LG - Samsung</div>
                <div>@lampa_group</div>
            </div>
        </div>
    </div>
</div>`

export default html